
    <button class="btn btn-success" data-toggle="modal" (click)="printData()">Print</button>

  